import {
  query,
  where,
  collection,
  getDocs,
  getDoc,
  limit,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";
import { useContext } from "react";
import { ProjectContext } from "../../AppContext/ProjectContext";
import { AuthContext } from "../../AppContext/AuthContext";
import { allProjectsQuery, deriveStatus } from "./project.queries";
import { customOrderByDESC } from "./helper";

export const getAllProjects = (communityCode, cb) => {
  getDocs(allProjectsQuery(communityCode)).then((doc) => {
    const dataSnaps = [];
    doc.forEach((each) => {
      const temp = each.data();
      const object = {
        ...temp,
        status: deriveStatus(temp),
        temp: temp.timestamp?.seconds || 0,
      };
      dataSnaps.push(object);
    });
    cb(customOrderByDESC(dataSnaps));
  }).catch((err) => {
    console.error("Failed to fetch projects:", err);
    cb([]);
  });
};

export const useProjectRetrieves = () => {
  const { setProjectInfo, projectInfo, createOrLoadDiscussion } =
    useContext(ProjectContext);
  const { userInfo } = useContext(AuthContext);

  const getProjectByProjectNumber = (projectNumber, communityCode) => {
    getDocs(
      query(
        collection(db, "projects"),
        where("projectNumber", "==", Number(projectNumber)),
        where("communityCode", "==", communityCode),
        limit(1)
      )
    ).then((docSnap) => {
      let project = null;

      docSnap.forEach((each) => {
        project = each.data();
      });
      if (project) {
        createOrLoadDiscussion(null, null, userInfo.communityCode, project);
      }
    }).catch((err) => {
      console.error("Failed to fetch project:", err);
    });
  };

  const updateProject = async (changes) => {
    const mergedChanges = {
      ...projectInfo,
      ...changes,
    };

    try {
      await updateDoc(doc(db, "projects", projectInfo.id), changes);
      setProjectInfo(mergedChanges);
    } catch (err) {
      console.error("Failed to update project:", err);
    }
  };

  return {
    getProjectByProjectNumber,
    updateProject,
  };
};
